import React, { useEffect, useState } from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import axios from 'axios';
import { toast } from 'sonner';
import { ChevronRight, Calendar, User, Phone, MessageSquare, CheckCircle2, MapPin, HeartPulse, Activity, ShieldCheck, Star } from 'lucide-react';
import { format } from 'date-fns';

import { slugify } from '../../utils/helpers';
const API = process.env.REACT_APP_BACKEND_URL;

const WhatsAppIcon = ({className="w-6 h-6"}) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.305-.885-.653-1.482-1.46-1.656-1.758-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01a1.054 1.054 0 0 0-.762.356c-.261.284-1.025 1.002-1.025 2.443s1.05 2.836 1.198 3.034c.149.198 2.065 3.155 5.002 4.423.699.303 1.245.484 1.67.62.702.223 1.34.191 1.84.116.564-.085 1.758-.718 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
  </svg>
);

// constants moved to state

export default function Home() {
  const [slider, setSlider] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [team, setTeam] = useState([]);
  const [baData, setBaData] = useState([]);
  const [corporate, setCorporate] = useState({ title: '', content: '', image: '' });
  const [blogs, setBlogs] = useState([]);
  const [settings, setSettings] = useState({});
  const [form, setForm] = useState({ name: '', phone: '', date: '', treatment: '', note: '' });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [patientReviews, setPatientReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/public/slider`).then(res => setSlider(res.data));
    axios.get(`${API}/api/public/treatments`).then(res => setTreatments(res.data));
    axios.get(`${API}/api/public/team`).then(res => setTeam(res.data));
    axios.get(`${API}/api/public/before-after`).then(res => setBaData(res.data));
    axios.get(`${API}/api/public/blog`).then(res => setBlogs(res.data));
    axios.get(`${API}/api/public/settings`).then(res => setSettings(res.data));
    axios.get(`${API}/api/public/corporate`).then(res => setCorporate(res.data));
    axios.get(`${API}/api/public/gallery`).then(res => setGalleryImages(res.data));
    axios.get(`${API}/api/public/testimonials`).then(res => setPatientReviews(res.data));
  }, []);

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/public/appointment`, form);
      setSubmitted(true);
      
      // WhatsApp Mesajını Hazırla
      const text = `*Yeni Online Randevu Talebi*
      
👤 *İsim:* ${form.name}
📱 *Telefon:* ${form.phone}
🗓️ *Tarih:* ${form.date}
🦷 *Tedavi:* ${form.treatment}
📝 *Not:* ${form.note || '-'}`;

      const whatsappUrl = `https://wa.me/905524818100?text=${encodeURIComponent(text)}`;
      
      // Yeni sekmede WhatsApp aç
      window.open(whatsappUrl, '_blank');
      
      setForm({ name: '', phone: '', date: '', treatment: '', note: '' });
      toast.success('Randevu talebiniz başarıyla oluşturuldu ve WhatsApp\'a yönlendiriliyorsunuz.');
    } catch (err) {
      toast.error('Talep gönderilirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${API}${url}`;
  };

  const getTreatmentSlug = (t) => t.id ? t.id : slugify(t.title);

  return (
    <div className="bg-slate-50 min-h-screen">
      <Navbar />

      {/* FLOATING WHATSAPP */}
      <a href="https://wa.me/905524818100" target="_blank" rel="noreferrer" className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform z-50 group flex items-center justify-center">
        <WhatsAppIcon className="w-8 h-8" />
        <span className="absolute right-full mr-4 bg-white text-slate-800 px-4 py-2 rounded-xl shadow-lg opacity-0 group-hover:opacity-100 transition-opacity font-medium whitespace-nowrap pointer-events-none">
          Yardıma mı ihtiyacınız var?
        </span>
      </a>

      {/* HERO SLIDER SECTION */}
      <section className="relative h-[85vh] min-h-[600px] w-full overflow-hidden" id="#">
        {slider.length > 0 ? (
          <>
            <div className="absolute inset-0 bg-slate-900">
              <img src={getImageUrl(slider[0].image)} alt="Clinic Hero" className="w-full h-full object-cover opacity-70" />
              <div className="absolute inset-0 hero-gradient" />
            </div>
            <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-8 flex flex-col justify-center pt-20">
              <div className="max-w-2xl text-white space-y-6 animate-in slide-in-from-bottom-8 duration-700">
                <div className="inline-block px-4 py-2 bg-primary/20 backdrop-blur-sm border border-primary/30 rounded-full text-primary-light font-semibold tracking-wide uppercase text-sm mb-2">
                  Dentakron Diş Kliniği
                </div>
                <h1 className="text-5xl md:text-7xl font-bold font-heading leading-[1.1] text-white">
                  {slider[0].title}
                </h1>
                <p className="text-xl text-slate-200 leading-relaxed font-light">
                  {slider[0].subtitle}
                </p>
                <div className="flex flex-wrap gap-4 pt-4">
                  <a href={slider[0].buttonLink} className="bg-primary text-white hover:bg-green-700 px-8 py-4 rounded-full font-bold transition-all transform hover:scale-105 inline-flex items-center gap-2 shadow-lg shadow-primary/30" data-testid="hero-randevu-btn">
                    {slider[0].buttonText} <ChevronRight className="w-5 h-5" />
                  </a>
                  <a href="#tedaviler" className="bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 px-8 py-4 rounded-full font-bold transition-all inline-flex items-center">
                    Tedavileri İncele
                  </a>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center bg-slate-200">
            <span className="text-slate-500">Yükleniyor...</span>
          </div>
        )}
      </section>

      {/* ABOUT US (Bizi Tanıyın) */}
      <section className="py-24 bg-white overflow-hidden" id="hakkimizda">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="aspect-[4/3] rounded-3xl overflow-hidden border border-slate-100 shadow-xl z-10 relative bg-slate-100">
                <img src={corporate.image ? getImageUrl(corporate.image) : "https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&w=800"} alt="Kurumsal" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-8 -right-8 bg-primary text-white p-8 rounded-3xl shadow-2xl z-20 w-64 hidden md:block">
                <div className="text-4xl font-bold font-heading mb-2">15+</div>
                <div className="text-sm font-medium uppercase tracking-wider text-primary-light">Yıllık Uzmanlık ve Tecrübe</div>
              </div>
            </div>
            <div className="space-y-6 lg:pl-8">
              <h2 className="text-primary font-bold tracking-wider uppercase text-sm">Bizi Tanıyın</h2>
              <h3 className="text-4xl font-bold font-heading text-slate-900 leading-tight">{corporate.title || 'Ankara Çankaya\'da Güvenilir Gülüşünüz İçin Buradayız'}</h3>
              <div className="text-lg text-slate-600 leading-relaxed max-h-[300px] overflow-y-auto pr-4 mb-4 custom-scrollbar whitespace-pre-wrap">
                {corporate.content || 'Ankara, Aşağı Öveçler\'de yer alan Dentakron Diş Kliniği olarak...'}
              </div>
              <div className="pt-6 grid sm:grid-cols-2 gap-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary flex-shrink-0"><Activity className="w-6 h-6" /></div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1">Modern Teknoloji</h4>
                    <p className="text-sm text-slate-500">Güncel ekipmanlarla ağrısız ve hızlı tedavi.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary flex-shrink-0"><ShieldCheck className="w-6 h-6" /></div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1">Garantili Sonuçlar</h4>
                    <p className="text-sm text-slate-500">Uzun ömürlü estetik ve fonksiyonel çözümler.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TREATMENTS SECTION */}
      {settings.showTreatments !== false && (
      <section className="py-24 bg-slate-50" id="tedaviler">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-bold font-heading text-slate-900 mb-6">Tedavilerimiz</h2>
            <p className="text-lg text-slate-600">
              Uzman hekim kadromuzla tam donanımlı kliniğimizde sunduğumuz diş tedavi hizmetlerimizi inceleyin.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {treatments.map((t, i) => (
              <a 
                href={`/tedaviler/${getTreatmentSlug(t)}`} 
                key={t.id || t.title} 
                className="group bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-all duration-300 flex flex-col h-full"
              >
                <div className="block h-64 overflow-hidden relative">
                  <div className="absolute inset-0 bg-primary/10 group-hover:bg-transparent transition-colors z-10 mix-blend-multiply" />
                  <img src={getImageUrl(t.image)} alt={t.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-8 flex-1 flex flex-col">
                  <h3 className="text-2xl font-bold font-heading text-slate-900 mb-3 group-hover:text-primary transition-colors block">{t.title}</h3>
                  <p className="text-slate-600 line-clamp-3 mb-6 flex-1">{t.description}</p>
                  <div className="mt-auto flex items-center text-primary font-bold text-sm uppercase tracking-wider">
                    <span className="flex items-center group-hover:underline">
                      Detaylı Bilgi <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-2 transition-transform" />
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* BEFORE / AFTER SECTION (Dynamic) */}
      {settings.showBeforeAfter !== false && (
      <section className="py-24 bg-slate-900 text-white" id="oncesi-sonrasi">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-bold font-heading mb-6">Öncesi ve Sonrası</h2>
            <p className="text-slate-400 text-lg">
              Estetik dokunuşlarla taçlandırdığımız mutlu gülüşler. Değişime şahit olun.
            </p>
          </div>

          {baData.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {baData.map((item, i) => (
                <div key={item.id || i} className="bg-slate-800 rounded-3xl p-4 border border-slate-700 hover:border-primary/50 transition-colors">
                  <h3 className="text-lg font-bold font-heading mb-4 text-center text-primary-light">{item.title}</h3>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="relative group">
                      <img src={getImageUrl(item.beforeImage)} alt="Before" className="w-full aspect-square object-cover rounded-2xl" />
                      <div className="absolute top-2 left-2 bg-black/60 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-bold">Öncesi</div>
                    </div>
                    <div className="relative group">
                      <img src={getImageUrl(item.afterImage)} alt="After" className="w-full aspect-square object-cover rounded-2xl" />
                      <div className="absolute top-2 right-2 bg-primary text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">Sonrası</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-slate-500 py-12">Yükleniyor veya henüz eklenmedi...</div>
          )}
        </div>
      </section>
      )}

      {/* KAYAR GALERİ (Marquee Carousel) */}
      {settings.showGallery !== false && galleryImages.length > 0 && (
      <section className="py-12 bg-white overflow-hidden border-b border-slate-100">
        <div className="flex w-[200%] animate-marquee hover:[animation-play-state:paused] gap-6 px-3">
          {[...galleryImages, ...galleryImages].map((item, i) => (
            <div key={i} className="w-80 h-64 flex-shrink-0 rounded-3xl overflow-hidden shadow-md">
              <img src={getImageUrl(item.image)} alt="Dentakron Klinik Ortamı" className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" />
            </div>
          ))}
        </div>
      </section>
      )}

      {/* TEAM SECTION (Reference Site Style - Tall Cards) */}
      {settings.showTeam !== false && (
      <section className="py-24 bg-white" id="hekimlerimiz">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-bold font-heading text-slate-900 mb-6">Uzman Kadromuz</h2>
            <p className="text-lg text-slate-600">
              Alanında uzman, tecrübeli ve güler yüzlü hekim kadromuz ile sağlığınız güvence altında.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {team.map((member, i) => (
              <div key={member.id || i} className="relative group rounded-3xl overflow-hidden aspect-[3/4] shadow-md border border-slate-100 hover:shadow-2xl transition-all duration-500">
                <img src={getImageUrl(member.image)} alt={member.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"></div>
                <div className="absolute bottom-0 left-0 w-full p-6 lg:p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <h3 className="text-2xl font-bold font-heading text-white mb-2">{member.name}</h3>
                  <p className="text-primary-light font-bold text-sm uppercase tracking-wider">{member.specialization}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* HASTA YORUMLARI */}
      {settings.showTestimonials !== false && patientReviews.length > 0 && (
      <section className="py-24 bg-primary/5" id="yorumlar">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-bold font-heading text-slate-900 mb-6">Hastalarımız Ne Diyor?</h2>
            <p className="text-lg text-slate-600">
              Dentakron Diş Kliniği olarak en büyük referansımız, kliniğimizden mutlu ayrılan hastalarımızdır.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {patientReviews.map((review, i) => (
              <div key={i} className="bg-white p-8 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white hover:border-primary/20 transition-colors flex flex-col">
                <div className="flex gap-1 mb-6 text-yellow-400">
                  {[...Array(review.rating)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" />)}
                </div>
                <p className="text-slate-700 leading-relaxed mb-8 flex-1 italic text-lg">"{review.text}"</p>
                <div className="flex items-center gap-4 border-t border-slate-100 pt-6">
                  <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center font-bold text-primary text-lg font-heading">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900">{review.name}</h4>
                    <p className="text-xs text-slate-500">{review.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* BLOGS SECTION */}
      {settings.showBlogs !== false && blogs.length > 0 && (
      <section className="py-24 bg-white" id="blog">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl font-bold font-heading text-slate-900 mb-6">Güncel Blog & Haberler</h2>
            <p className="text-lg text-slate-600">
              Ağız ve diş sağlığı hakkında merak ettikleriniz, uzmanlarımızdan tavsiyeler ve kliniğimizden son gelişmeler.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blogs.map((b, i) => (
              <div key={b.id || i} className="bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl transition-all group flex flex-col">
                <div className="h-56 overflow-hidden relative block">
                  <a href={`/blog/${slugify(b.title)}`}>
                    <img src={getImageUrl(b.image)} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </a>
                </div>
                <div className="p-8 flex flex-col flex-1">
                  <a href={`/blog/${slugify(b.title)}`} className="text-xl font-bold text-slate-900 mb-3 font-heading group-hover:text-primary transition-colors">{b.title}</a>
                  <p className="text-slate-600 line-clamp-3 text-sm mb-6 flex-1 leading-relaxed">{b.content}</p>
                  <a href={`/blog/${slugify(b.title)}`} className="text-primary font-bold text-sm uppercase tracking-wider inline-flex items-center">Devamını Oku <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" /></a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* APPOINTMENT & CONTACT SECTION */}
      {settings.showContact !== false && (
      <section className="py-24 bg-slate-900" id="randevu">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Contact Info */}
            <div className="space-y-8 lg:pr-8 text-white" id="iletisim">
              <div>
                <h2 className="text-4xl font-bold font-heading text-white mb-6">İletişim & Randevu</h2>
                <p className="text-lg text-slate-300 leading-relaxed">
                  Aşağı Öveçler Mahallesi, Kabil Caddesi'ndeki merkezimize ulaşmak veya online randevu oluşturmak için yandaki formu doldurabilir ya da WhatsApp hattımızdan direkt bize yazabilirsiniz.
                </p>
              </div>
              <div className="space-y-6 pt-4">
                <div className="flex items-center gap-4 group">
                  <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center text-primary-light shadow-sm flex-shrink-0 group-hover:bg-primary transition-colors">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1">Telefon</h4>
                    <p className="text-xl font-semibold text-white">{settings.phone}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4 group">
                  <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center text-primary-light shadow-sm flex-shrink-0 group-hover:bg-primary transition-colors">
                    <MapPin className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1">Adres</h4>
                    <p className="text-lg text-white font-medium">{settings.address}</p>
                  </div>
                </div>
              </div>
              {settings.mapLink && (
                <div className="h-64 w-full rounded-3xl overflow-hidden border border-white/10 shadow-sm mt-8 relative">
                  <div className="absolute inset-0 bg-slate-900/20 pointer-events-none" />
                  <iframe src={settings.mapLink} width="100%" height="100%" style={{ border: 0, filter: 'contrast(1.1)' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Map"></iframe>
                </div>
              )}
            </div>

            {/* Appointment Form */}
            <div className="bg-white p-10 rounded-[2.5rem] shadow-2xl border border-slate-100">
              <h3 className="text-2xl font-bold font-heading text-slate-900 mb-8">Online Randevu Formu</h3>
              {submitted ? (
                <div className="text-center py-16 bg-primary/5 rounded-3xl border border-primary/20">
                  <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6 text-white shadow-lg shadow-primary/30">
                    <CheckCircle2 className="w-10 h-10" />
                  </div>
                  <h4 className="text-2xl font-bold text-slate-900 mb-2">Talebiniz Alındı!</h4>
                  <p className="text-slate-600 max-w-sm mx-auto">En kısa sürede iletişim numaranızdan size ulaşıp randevunuzu onaylayacağız.</p>
                  <button onClick={() => setSubmitted(false)} className="mt-8 text-primary font-bold hover:text-primary-hover">Yeni Randevu Al</button>
                </div>
              ) : (
                <>
                  <form onSubmit={handleAppointmentSubmit} className="space-y-6">
                    <div>
                      <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-2"><User className="w-4 h-4 text-primary" /> Ad Soyad</label>
                      <input type="text" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-primary outline-none transition-all" placeholder="Adınız ve Soyadınız" data-testid="appointment-name" />
                    </div>
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-2"><Phone className="w-4 h-4 text-primary" /> Telefon</label>
                        <input type="tel" required value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-primary outline-none transition-all" placeholder="05XX XXX XX XX" data-testid="appointment-phone" />
                      </div>
                      <div>
                        <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-2"><Calendar className="w-4 h-4 text-primary" /> Tercih Edilen Tarih</label>
                        <input type="date" required value={form.date} onChange={e => setForm({...form, date: e.target.value})} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-primary outline-none transition-all" data-testid="appointment-date" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-primary" /> Tedavi Seçimi</label>
                      <select required value={form.treatment} onChange={e => setForm({...form, treatment: e.target.value})} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-primary outline-none transition-all appearance-none" data-testid="appointment-treatment">
                        <option value="">Lütfen Tedavi Seçin</option>
                        {treatments.map(t => <option key={t.id || t.title} value={t.title}>{t.title}</option>)}
                        <option value="Genel Kontrol">Genel Kontrol / Muayene</option>
                        <option value="Diğer">Diğer</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-bold text-slate-700 mb-2 flex items-center gap-2"><MessageSquare className="w-4 h-4 text-primary" /> Ek Notunuz (Opsiyonel)</label>
                      <textarea rows="3" value={form.note} onChange={e => setForm({...form, note: e.target.value})} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:bg-white focus:ring-2 focus:ring-primary outline-none transition-all resize-none" placeholder="Belirtmek istediğiniz bir şikayetiniz var mı?"></textarea>
                    </div>
                    <button type="submit" disabled={loading} className="w-full bg-primary hover:bg-green-700 text-white font-bold py-4 rounded-2xl shadow-lg shadow-primary/30 transition-all transform hover:-translate-y-1">
                      {loading ? 'Gönderiliyor...' : 'Randevu Talebi Oluştur'}
                    </button>
                  </form>
                  
                  <div className="mt-6 flex items-center justify-center gap-4 text-slate-400">
                    <span className="h-px w-12 bg-slate-200"></span>
                    <span className="text-sm font-medium uppercase">Veya</span>
                    <span className="h-px w-12 bg-slate-200"></span>
                  </div>

                  <a href="https://wa.me/905524818100" target="_blank" rel="noreferrer" className="w-full flex items-center justify-center gap-3 bg-[#25D366] text-white py-4 rounded-2xl font-bold mt-6 hover:bg-[#20bd5a] transition-colors shadow-lg shadow-[#25D366]/30 group">
                    <WhatsAppIcon className="w-6 h-6 group-hover:scale-110 transition-transform" />
                    WhatsApp ile Hızlı Ulaşın
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      )}

      <Footer />
    </div>
  );
}
